import { Monitor, Moon, Sun } from 'lucide-react';

import { useI18n } from '../../i18n/I18nProvider';
import { cn } from '../../lib/cn';

import { useTheme, type Theme } from './ThemeProvider';

// Botón que cicla la preferencia de tema: sistema → claro → oscuro → sistema.
// El ícono refleja la preferencia actual. `tone="onDark"` para fondos oscuros
// (ej. el header verde); `default` para superficies claras/oscuras normales.
const ORDEN: readonly Theme[] = ['system', 'light', 'dark'];
const ICONO = { system: Monitor, light: Sun, dark: Moon } as const;

export function ThemeToggle({
  tone = 'default',
  className,
}: {
  tone?: 'onDark' | 'default';
  className?: string;
}): JSX.Element {
  const { theme, setTheme } = useTheme();
  const t = useI18n();
  const label = { system: t.tema.sistema, light: t.tema.claro, dark: t.tema.oscuro } as const;
  const Icon = ICONO[theme];
  const siguiente = ORDEN[(ORDEN.indexOf(theme) + 1) % ORDEN.length]!;

  return (
    <button
      type="button"
      onClick={() => setTheme(siguiente)}
      aria-label={t.tema.cambiar}
      title={`${t.tema.cambiar}: ${label[theme]}`}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2',
        tone === 'onDark'
          ? 'text-white/80 hover:bg-white/10 hover:text-white focus-visible:ring-white/60'
          : 'text-text-subtle hover:bg-surface-muted hover:text-text-strong focus-visible:ring-marca-primario',
        className,
      )}
    >
      <Icon size={18} />
    </button>
  );
}
